import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GlobalProvider } from "./Context/GlobalState";
import "bootstrap/dist/css/bootstrap.min.css";
import SecurityWrapper from "./SecurityWrapper";

const isEmployeeWidgetBuild =
  process.env.REACT_APP_BUILD_TARGET === "employee-form-widget";
const isEmployeeListWidgetBuild =
  process.env.REACT_APP_BUILD_TARGET === "employee-list-widget";
const isEmployeeWidgetsBuild =
  process.env.REACT_APP_BUILD_TARGET === "employee-widgets";
const RootComponent = isEmployeeWidgetBuild
  ? require("./widgets/employee-form/EmployeeFormAdminWidgetPage").default
  : isEmployeeListWidgetBuild
  ? require("./widgets/employee-list/EmployeeListAdminWidgetPage").default
  : isEmployeeWidgetsBuild
  ? require("./widgets/EmployeeWidgetsApp").default
  : require("./App").default;

const root = ReactDOM.createRoot(document.getElementById("root"));

if (isEmployeeWidgetBuild || isEmployeeListWidgetBuild || isEmployeeWidgetsBuild) {
  root.render(
    <BrowserRouter>
      <RootComponent />
    </BrowserRouter>
  );
} else {
  root.render(
    <SecurityWrapper>
      <GlobalProvider>
        <BrowserRouter>
          <RootComponent />
        </BrowserRouter>
      </GlobalProvider>
    </SecurityWrapper>
  );
}
